import angularModule from 'ClientConfig/angularModule/scripts/client_config_module';
import BuildConfig from 'BuildConfig';
import reloadWindow from 'reloadWindow';
import { AppLauncher } from '@capacitor/app-launcher';

angularModule.factory('ClientConfig', [
    '$injector',

    $injector => {
        const SuperModel = $injector.get('SuperModel');
        const $window = $injector.get('$window');

        const ClientConfig = SuperModel.subclass(function () {
            const self = this;
            ['upgradeInstructions', 'upgradeButtonText'].forEach(prop => {
                Object.defineProperty(self.prototype, prop, {
                    get() {
                        const translateKey = `client_config.client_config.${this[`${prop}Key`]}`;
                        // lazy injection to prevent circ. dependency
                        return $injector.get('$translate').instant(translateKey);
                    },
                });
            });

            return {
                initialize(versionNumber) {
                    this.versionNumber = versionNumber;
                },
            };
        });

        const WebClientConfig = ClientConfig.subclass(() => ({
            identifier: 'web',
            upgradeInstructionsKey: 'web_upgrade_instructions',
            upgradeButtonTextKey: 'web_upgrade_button_text',

            upgrade(EventLogger) {
                reloadWindow({ label: 'web_client_config', EventLogger });
            },
        }));

        const NativeAppConfig = ClientConfig.subclass(() => ({
            upgradeInstructionsKey: 'native_upgrade_instructions',
            upgradeButtonTextKey: 'native_upgrade_button_text',

            upgrade(_) {
                const ErrorLogService = $injector.get('ErrorLogService');
                const url = this.storeUrl();
                if (!url) {
                    ErrorLogService.notify('Cannot open the app store without a store id', null, {
                        identifier: this.identifier,
                        appIdentifier: $window.CORDOVA?.appIdentifier,
                    });
                    return Promise.resolve();
                }
                return AppLauncher.openUrl({ url })
                    .then(({ completed }) => {
                        if (!completed) ErrorLogService.notify('Failed to open the app store', null, { url });
                    })
                    .catch(err => ErrorLogService.notify('Failed to open the app store', err, { url }));
            },
        }));

        const IosClientConfig = NativeAppConfig.subclass(() => ({
            identifier: 'ios',

            storeUrl() {
                const appStoreId = $window.CORDOVA?.appStoreId;
                return appStoreId ? `itms-apps://apps.apple.com/app/${appStoreId}` : null;
            },
        }));

        const AndroidClientConfig = NativeAppConfig.subclass(() => ({
            identifier: 'android',

            storeUrl() {
                const appIdentifier = $window.CORDOVA?.appIdentifier;
                return appIdentifier ? `market://details?id=${appIdentifier}` : null;
            },
        }));

        const Klass =
            {
                web: WebClientConfig,
                ios: IosClientConfig,
                android: AndroidClientConfig,
            }[window.clientIdentifier] || WebClientConfig;

        const instance = new Klass(Number(BuildConfig.build_number));

        return {
            current: instance,
        };
    },
]);
